// src/app/components/pages/product-details/product-details.component.ts

import {
    Component,
    OnInit,
    HostListener
}
from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    FormBuilder,
    FormGroup,
    Validators
} from '@angular/forms';

import { DataService } from '../../../../shared/data/data.service';
import { CartService } from '../../../../shared/services/cart.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],

})
export class ProductDetailsComponent implements OnInit {

    productId: string = '';
    product: any = {};
    images: string[] = [];
    selectedImage: string = '';
    visibleThumbnailStart = 0;
    maxVisibleThumbnails = 6;
    quantity: number = 1;
    isSubmitting = false;
    showFullDescription = false;
    /* TABS */
    activeTab:
        'reviews'
        | 'details'
        | 'description'
        | 'specifications'
        = 'reviews';
    /* ZOOM MODAL */
    showZoomModal = false;
    showReviewModal = false;
    selectedReview: any = null;
    zoomLevel = 1;
    zoomStep = 0.25;
    transformOrigin = 'center center';
    /* REVIEW GRID */
    reviewsPerPage = 3;
    /* PRODUCT DETAILS EXCLUDE */
    excludedFields = [
        'id',
        'description',
        'brand_name',
        'category',
        'images'
    ];

    relatedProducts: any[] = [];

    reviews: any[] = [];

    pagedReviews: any[] = [];

    currentReviewPage = 1;

    totalReviewPages = 1;

    reviewPages: number[] = [];
    readonly stars = [1, 2, 3, 4, 5];
    reviewForm!: FormGroup;

    constructor(
        private route: ActivatedRoute,
        public dataService: DataService,
        private cartService: CartService,
        private fb: FormBuilder,
        private router: Router
    ) { }

    ngOnInit(): void {

        this.initializeReviewForm();

        this.route.paramMap.subscribe(params => {

            this.productId = params.get('id') || '';

            if (this.productId) {

                this.loadProduct();

                this.loadReviews();

            }

        });

    }

    initializeReviewForm(): void {

        this.reviewForm = this.fb.group({

            rating: [
                '',
                [
                    Validators.required,
                    Validators.min(0),
                    Validators.max(5)
                ]
            ],

            review_comment: [
                '',
                Validators.required
            ]

        });

    }

    loadProduct(): void {

        this.dataService
            .getProductDetail(this.productId)
            .subscribe({

                next: (response: any) => {

                    if (
                        response.status === 1 &&
                        response.data
                    ) {

                        this.product =
                            response.data.product;

                        this.images =
                            this.product.images || [];

                        if (
                            this.images.length > 0
                        ) {

                            this.selectedImage =
                                this.images[0];

                        }

                        this.loadRelatedProducts();

                    }

                },

                error: (error) => {

                    console.error(
                        error
                    );

                }

            });

    }

selectImage(image: string): void {

    this.selectedImage = image;

}
get visibleThumbnails(): string[] {
    return this.images.slice(
        this.visibleThumbnailStart,
        this.visibleThumbnailStart + this.maxVisibleThumbnails
    );
}
nextThumbnails(): void {
    if (
        this.visibleThumbnailStart +
        this.maxVisibleThumbnails <
        this.images.length
    ) {
        this.visibleThumbnailStart++;
    }
}

previousThumbnails(): void {
    if (this.visibleThumbnailStart > 0) {
        this.visibleThumbnailStart--;
    }
}


    getSavingsAmount(): number {

        if (
            !this.product.product_cost ||
            !this.product.mrp_price
        ) {

            return 0;

        }

        return (
            Number(
                this.product.mrp_price
            ) -
            Number(
                this.product.product_cost
            )
        );

    }

    getDiscountPercentage(): number {

        if (
            !this.product.product_cost ||
            !this.product.mrp_price
        ) {

            return 0;

        }

        return Math.round(

            (
                this.getSavingsAmount()
                /
                Number(
                    this.product.mrp_price
                )
            )

            * 100

        );

    }

    increaseQuantity(): void {

        this.quantity++;

    }

    decreaseQuantity(): void {

        if (
            this.quantity > 1
        ) {

            this.quantity--;

        }

    }

    addToCart(): void {

        const cartItem = {

            ...this.product,

            quantity:
                this.quantity,

            image:
                this.selectedImage,

            price:

                this.product.product_cost ||

                this.product.mrp_price

        };

        this.cartService
            .addToCart(
                cartItem
            );

    }

    toggleWishlist(): void {

        const customerId =
            localStorage.getItem(
                'customer_id'
            );

        if (!customerId) {

            return;

        }

        // call wishlist API here

    }

    shareProduct(): void {

        if (
            navigator.share
        ) {

            navigator.share({

                title:
                    this.product.product_name,

                text:
                    this.product.description,

                url:
                    window.location.href

            });

        }
        else {

            navigator.clipboard
                .writeText(
                    window.location.href
                );

            alert(
                'Link copied to clipboard'
            );

        }

    }

    loadRelatedProducts(): void {

        this.dataService
            .getRelatedProducts(
                this.productId
            )
            .subscribe({
                next: (
                    response: any
                ) => {
                    if (
                        response.status === 1
                    ) {
                        this.relatedProducts =
                            response.data;
                    }
                }
            });
    }

    loadReviews(): void {

        this.dataService
            .getProductReviews(
                this.productId
            )
            .subscribe({

                next: (
                    response: any
                ) => {

                    if (
                        response.status === 1
                    ) {

                        this.reviews =
                            response.data;

                        this.setupReviewPagination();

                    }

                }

            });

    }

submitReview(): void {

    const customerId =
        localStorage.getItem(
            'customer_id' 
        );

    if (!customerId) {

        Swal.fire({

            icon: 'warning',

            title: 'Login Required',

            text:
                'Please login first.',

            confirmButtonColor:
                '#ff6b35'

        });

        return;
    }

    if (
        this.reviewForm.invalid
    ) {

        this.reviewForm
            .markAllAsTouched();

        return;
    }

    const payload = {

        customer_id:
            customerId,

        product_id:
            this.productId,

        rating:
            this.reviewForm.value.rating,

        review_comment:
            this.reviewForm.value.review_comment

    };

    this.isSubmitting = true;

    this.dataService
        .saveReview(payload)

        .subscribe({

            next: (
                response: any
            ) => {

                this.isSubmitting = false;

                if (
                    response.status === 1
                ) {

                    Swal.fire({

                        icon: 'success',

                        title:
                            'Success',

                        text:
                            response.message,

                        timer: 2000,

                        showConfirmButton:
                            false

                    });

                    this.reviewForm.reset();

                    this.loadReviews();
                }

                else {

                    Swal.fire({

                        icon: 'error',

                        title:
                            'Oops...',

                        text:
                            response.message,

                        confirmButtonColor:
                            '#ff6b35'

                    });
                }

            },

            error: (error) => {

    this.isSubmitting = false;

    console.log(error);

    Swal.fire({

        icon: 'error',

        title: 'Error',

        text: error.error?.message || 'Something went wrong.'

    });

}

        });

}

    setupReviewPagination(): void {
        this.totalReviewPages =
            Math.ceil(
                this.reviews.length
                /
                this.reviewsPerPage
            );
        this.reviewPages =
            Array(
                this.totalReviewPages
            )
            .fill(0)
            .map(
                (
                    x,
                    i
                ) => i + 1
            );
        this.changeReviewPage(
            1
        );
    }

    changeReviewPage(
        page: number
    ): void {
        if (
            page < 1 ||
            page >
            this.totalReviewPages
        ) {
            return;
        }
        this.currentReviewPage =
            page;
        const start =
            (
                page - 1
            )
            *
            this.reviewsPerPage;
        const end =
            start +
            this.reviewsPerPage;
        this.pagedReviews =
            this.reviews.slice(
                start,
                end
            );
    }
    getStars(
        rating: number
    ): number[] {
        return Array(
            Math.round(
                rating
            )
        ).fill(0);
    }
openRelatedProduct(id: string): void {

    this.router.navigate(
        ['/product-details', id]
    );

    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });

}
imageError(event: any) {
    console.log('Failed image:',
        event.target.src);
}
setTab(
    tab:
    'reviews'
    | 'details'
    | 'description'
    | 'specifications'
): void {

    this.activeTab = tab;

    setTimeout(() => {

        const tabs =
            document.querySelector(
                '.product-tabs'
            );

        tabs?.scrollIntoView({

            behavior: 'smooth',

            block: 'start'

        });

    }, 100);
}

goToDescription(): void {

    this.setTab(
        'description'
    );
}
openZoomModal(): void {

    this.showZoomModal = true;

    this.zoomLevel = 1;

    document.body.style.overflow =
        'hidden';
}

closeZoomModal(): void {
    this.showZoomModal = false;
    this.zoomLevel = 1;
    document.body.style.overflow =
        'auto';
}

openReviewModal(review: any): void {
    this.selectedReview = review;
    this.showReviewModal = true;
    document.body.style.overflow = 'hidden';
}

closeReviewModal(): void {
    this.showReviewModal = false;
    this.selectedReview = null;
    document.body.style.overflow = 'auto';
}

zoomIn(): void {

    this.zoomLevel +=
        this.zoomStep;
}

zoomOut(): void {

    if (
        this.zoomLevel > 1
    ) {

        this.zoomLevel -=
            this.zoomStep;
    }
}

onZoomMove(
    event: MouseEvent
): void {

    const target =
        event.currentTarget as HTMLElement;

    const rect =
        target.getBoundingClientRect();

    const x =
        (
            (
                event.clientX -
                rect.left
            )
            /
            rect.width
        ) * 100;

    const y =
        (
            (
                event.clientY -
                rect.top
            )
            /
            rect.height
        ) * 100;

    this.transformOrigin =
        `${x}% ${y}%`;
}

nextImage(): void {

    if (
        !this.images.length
    ) return;

    const currentIndex =
        this.images.indexOf(
            this.selectedImage
        );

    const nextIndex =
        (
            currentIndex + 1
        )
        %
        this.images.length;

    this.selectedImage =
        this.images[
            nextIndex
        ];
}

previousImage(): void {

    if (
        !this.images.length
    ) return;

    const currentIndex =
        this.images.indexOf(
            this.selectedImage
        );

    const previousIndex =
        currentIndex === 0
            ?
            this.images.length - 1
            :
            currentIndex - 1;

    this.selectedImage =
        this.images[
            previousIndex
        ];
}

buyNow(): void {

    this.addToCart();

    this.router.navigate(
        ['/cart']
    );
}

getProductDetails():
{ key: string; value: any }[] {

    return Object
        .entries(this.product)

        .filter(
            ([key, value]) =>

                value !== null &&

                value !== '' &&

                !this.excludedFields.includes(key)
        )

        .map(([key, value]) => ({

            key:

                key

                .replace(
                    'category_name',
                    'Category'
                )

                .replace(
                    'brand_name',
                    'Brand'
                )

                .replace(
                    /_/g,
                    ' '
                )

                .replace(
                    /\b\w/g,

                    c => c.toUpperCase()
                ),

            value

        }));
}

@HostListener(
    'document:keydown.escape'
)

onEscape(): void {

    if (this.showZoomModal) {

        this.closeZoomModal();

    }

    if (this.showReviewModal) {

        this.closeReviewModal();

    }

}

get averageRating(): number {

    if (!this.reviews.length) {

        return 0;

    }

    const total = this.reviews.reduce(

        (sum, review) => sum + Number(review.rating),

        0

    );

    return total / this.reviews.length;

}
goToReviews(): void {

    this.setTab('reviews');

}
setRating(rating: number): void {

    this.reviewForm.patchValue({

        rating: rating

    });

}
addRelatedToCart(product: any): void {

    const cartItem = {

        ...product,

        quantity: 1,

        image: product.product_image,

        price:
            product.product_cost
            ||
            product.mrp_price
    };

    this.cartService.addToCart(cartItem);
}

}